import { useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { getdatabyId } from "../../redux/action-creators/adoptionAction";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import ProductSidebar from "../../components/sidebars/ProductSidebar";
import { ProductStyles } from "../products/ProductsStyle";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { Type } from "../../utils/constants";
import SocialIconSection from "../../components/sidebars/SocialIconSection";

const PetsLostFoundDetail = () => {
  const history = useHistory();
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const styleClasses = ProductStyles();
  const dispatch = useDispatch();
  const user_Id = localStorage.getItem("userId");
  const type = Type["lost&found"];
  const { id }: { id: string } = useParams();

  const [Images, setImages] = useState([]);
  const [Status, setStatus] = useState('');
  const [lostFoundDetail, setLostFoundDetail] = useState([]);
  const [foundUser, setFoundUser] = useState([]);
  
  const handleButtonClick = (pet_id: string) => {
    history.push('/pets-found/' + pet_id); // Navigate to '/new-path'
  };

  /**
   * Function To get the details of pets
   * @param id
   */
  const petDetails = useCallback(
    async (id: string) => {
      const result: any = await dispatch(getdatabyId(id, type));
      const response = result?.data?.data;
      if (response && response.length) {
        setLostFoundDetail(response);
        setFoundUser(result?.founderData);
        let data = response[0]?.image;
        let status = response[0]?.status;
        data = JSON.parse(data);
        setImages(data);
        setStatus(status);
      }
    },
    [dispatch, type]
  );
  useEffect(() => {
    petDetails(id);
  }, [id, petDetails]);
  
  return (
    <Box>
      <Box className={commonStyle.windowColor}>
        <Grid container>
          <Grid item md={3}>
            <LeftSidebar />
            {/* <SocialIconSection /> */}
          </Grid>

          <Grid item md={6}>
            <Box className={`${commonStyle.p20}`}>
              <Box
                className={`${commonStyle.bgWhite} ${styleClasses.combineBox}`}
              >
                <Box
                  className={`${commonStyle.p20} ${commonStyle.card} ${styleClasses.productDetailCard}`}
                >
                  <img
                    src={Images[0] ? Images[0] : null}
                    alt={translation("imgalt_product")}
                  // className={styleClasses.productCardImg}
                  // style={{objectFit: "contain",}}
                  />
                </Box>

                <Grid container spacing={2} className={commonStyle.mt10}>
                  {Images.length > 0 &&
                    Images.slice(1).map((item, index) => (
                      <Grid key={index} item lg={4}>
                        <Box
                          className={`${commonStyle.flexCenter} ${commonStyle.card} ${styleClasses.productDetailCard}`}
                        >
                          <img src={item} alt={translation("image")} />
                        </Box>
                      </Grid>
                    ))}
                </Grid>
                {user_Id != lostFoundDetail[0]?.userId && Status === "lost" ? (
                  <Box className={`${commonStyle.justifyCenter} ${commonStyle.dflex}`}>
                    <button onClick={(event) => handleButtonClick(id)}
                      style={{ border: "none" }}
                      className={`
                      ${commonStyle.mt10} 
                      ${commonStyle.bgSkyBlue} 
                      ${commonStyle.btnWidth} 
                      ${commonStyle.white} 
                      ${commonStyle.py10} 
                      ${commonStyle.weightLight} 
                      ${commonStyle.borderRad8} 
                      ${commonStyle.font16} 
                      `}>
                      {translation("It has been found")}
                    </button>
                    {/* </Grid> */}
                  </Box>
                ) : null}
              </Box>
            </Box>
          </Grid>

          <Grid item md={3}>
            <ProductSidebar id={id} type={type} userList={lostFoundDetail} foundUser={foundUser} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PetsLostFoundDetail;
